import { Component, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import 'rxjs/add/operator/filter';
import { Router, NavigationEnd } from '@angular/router';
import { DocsLink } from 'src/app/shared/constants/docs-link';
import { AuthenticationService } from './core/services/authentication.service';
import { AppSelectorService } from './shared/services/app-selector/app-selector.service';
import { DatacontextService } from './data/datacontext.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  subscription: Subscription;
  public isAuthenticated: any = false;
  public docLinks = DocsLink.sdkIntegrationDocLinks;
  public showDisclaimer = false;
  public selectedApp: any = {};
  public plan: any;
  shouldShowSidebar: boolean = false;

  constructor(private authentication: AuthenticationService, private datacontextService: DatacontextService, private appSelectorService: AppSelectorService, private router: Router) {
    this.isAuthenticated = this.authentication.isAuthenticated();
  }

  ngOnInit() {
    if (this.isAuthenticated) {
      this.getPlanForCompany();
      const ssoLogin = this.authentication.getLocalStorageKey('ssoLogin');
      if (ssoLogin) {
        this.fetchSSOUserStatus(true);
      }
    }
    this.watchRouteChange();
    this.watchAppChange();
  }

  @HostListener('document:click', ['$event'])
  handlePageClick(event: any) {
    if (!event.target.classList.contains('custom-menu-container')) {
      this.appSelectorService.toggleAppDropdown$.next();
    }
  }

  getPlanForCompany() {
    this.datacontextService.user.getUserCompany((res: any) => {
      const _companyDetails = res.api_response.companies[0];
      delete _companyDetails.apps;
      this.plan = _companyDetails.plan;
    });
  }

  watchRouteChange() {
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        if (event['url']) {
          const currentUrl = event['url'];

          if (currentUrl.includes('redirecting-to-netcore-ce') || currentUrl.includes('ce-request-access') || currentUrl.includes('ce-authenticate') || currentUrl.includes('onsite-journey')) {
            this.shouldShowSidebar = true
          } else {
            this.shouldShowSidebar = false;
          }

          const ignorePages = ['overview', 'settings', 'user-settings'];
          let flag = true;
          if (event['url'] === '/') {
            this.showDisclaimer = false;
            return;
          }
          for (let i = 0; i < ignorePages.length; i++) {
            let page = ignorePages[i];
            if (page === 'settings') {
              if (currentUrl.includes(page) && currentUrl.includes("app-settings")) {
                flag = true;
                break;
              }
            }
            if (currentUrl.includes(page)) {
              flag = false;
              break;
            }
          }
          this.showDisclaimer = flag;
        }
      });
  }

  watchAppChange() {
    this.appSelectorService.getAppChangedListener().subscribe((selectedApp) => {
      this.selectedApp = selectedApp;
    });
  }

  fetchSSOUserStatus(status) {
    this.authentication.fetchSSOUserStatus(status);
  }
}
